module.exports = __webpack_public_path__ + "img/Nopng.bbfcf060.png";